import { type ReactElement } from 'react';
import clsx from 'clsx';

import { Box } from '@mui/material';

import styles from './AnychartProgress.module.css';

export type AnychartProgressProps = {
  size: number | 'small' | 'medium' | 'large';
};

const sizes = {
  small: 35,
  medium: 50,
  large: 80,
};

export default function AnychartProgress({ size }: AnychartProgressProps): ReactElement {
  const isNumber = typeof size === 'number';

  return (
    <Box
      className={styles.root}
      sx={{
        width: isNumber ? `${size}px` : sizes[size],
        height: isNumber ? `${size}px` : sizes[size],
      }}
    >
      <div className={styles.chartRow}>
        <span className={clsx(styles.chartCol, styles.green)} />
        <span className={clsx(styles.chartCol, styles.orange)} />
        <span className={clsx(styles.chartCol, styles.red)} />
      </div>
    </Box>
  );
}
